import { GestionAfiliadoBeneficiariosEdicion } from "./GestionAfiliadoBeneficiariosEdicion";
import { GestionAfiliadoEdicion } from "./GestionAfiliadoEdicion";

export class GestionAfiliadoEdicionRegistro {
    item: GestionAfiliadoEdicion;
    listaBeneficiarios: GestionAfiliadoBeneficiariosEdicion[];
    filtroGestionAfiliado: string;
}